import React from 'react';
import ActionPillMenu from '../ui/ActionPillMenu';
import { ACTION_PILL_QUIET_CLASS } from './eventStyles';
import { DEFAULT_EVENT_WORDS } from './eventWords';

// Per-event actions, built on the Action Pill Standard (flyover pills that cascade in, shared hover pulse).
// Only what an event can do for now: open/edit it, or cancel it. Confirming and completing arrive later.
export default function EventActionsMenu({ event, canEdit, onEdit, onCancel, onGuests, onPlan, words = DEFAULT_EVENT_WORDS }) {
    const canceled = event.engagement?.status === 'canceled';
    const options = [
        ...(onGuests ? [{ key: 'guests', label: 'Guests & RSVP', onSelect: () => onGuests(event) }] : []),
        { key: 'open', label: canEdit ? 'Edit details' : 'View details', onSelect: () => onEdit(event) },
        // M19 Events Foundation: client, automation, day plan, invitee travel and rides.
        ...(onPlan ? [{ key: 'plan', label: 'Plan, travel & rides', onSelect: () => onPlan(event.engagement_id) }] : []),
    ];
    if (canEdit) {
        options.push({ key: 'cancel', label: `Cancel ${words.eventLower}`, disabled: canceled, title: canceled ? 'Already canceled' : undefined, onSelect: () => onCancel(event) });
    }
    const menu = (
        <ActionPillMenu
            menuLabel={`Actions for ${event.event_name}`}
            placement="top"
            align="end"
            size="compact"
            options={options}
            onTriggerClick={() => onEdit(event)}
            triggerClassName={ACTION_PILL_QUIET_CLASS}
            triggerProps={{ 'aria-label': `Open ${event.event_name}` }}
        >
            <span>Open</span>
            <span aria-hidden="true">▾</span>
        </ActionPillMenu>
    );
    if (!onGuests) return menu;
    // Module 19 G2: the guest list opens straight from the event's card or row.
    return (
        <div className="flex flex-wrap items-center justify-end gap-2">
            <button type="button" onClick={() => onGuests(event)} className={ACTION_PILL_QUIET_CLASS} aria-label={`Guests and RSVP for ${event.event_name}`}>Guests</button>
            {menu}
        </div>
    );
}
